export const formatString = (str, ...args) => {
  // formatString("a{0}bcd{1}ef","foo", "bar");
  // formatString("Hello, {name}, are you feeling {adjective}?", { name: "Gabriel", adjective: "OK" });
  if (args.length) {
    var t = typeof args[0];
    var key;
    var _args =
      "string" === t || "number" === t
        ? Array.prototype.slice.call(args)
        : args[0];

    for (key in _args) {
      str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), _args[key]);
    }
  }

  return str;
};

export const getCurrencySymbol = (currency, locale) =>
  new Intl.NumberFormat(locale, { style: 'currency', currency })
    .formatToParts(1)
    .find(x => x.type === "currency")
    .value;
